import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.ichigojam = bracketIndenting({
	line: "'",
})
